// export default function Nav({}) {
//   return (
//     <div className="flex flex-row justify-center items-center fixed bottom-0 w-full">
//       <div className="bg-slate-900 border w-1/3 text-center p-3">Deck</div>
//       <div className="bg-slate-900 border w-1/3 text-center p-3">Card DB</div>
//       <div className="bg-slate-900 border w-1/3 text-center p-3">Stats</div>
//     </div>
//   );
// }

import React from "react";
import { Tabs, Tab } from "@heroui/react";
import { IconChartPie, IconCards, IconDatabase } from "@tabler/icons-react";
import LAYOUTS from "@/components/DeckBuilder/layouts";

export default function Nav({
  getDeckCount,
  view,
  setView,
}: {
  getDeckCount: any;
  view: any;
  setView: any;
}) {
  return (
    <div className="absolute z-40 bottom-0 mb-2 w-full">
      <div className="flex w-full items-center justify-center flex-col">
        <Tabs
          aria-label="Options"
          color="primary"
          variant="bordered"
          selectedKey={view || "mobile-deck"}
          onSelectionChange={setView}
        >
          <Tab
            key={LAYOUTS.EDIT}
            title={
              <div className="flex items-center space-x-2">
                <IconDatabase />
                <span>Card DB</span>
              </div>
            }
          />
          <Tab
            key={LAYOUTS.DECK}
            title={
              <div className="flex items-center space-x-2">
                <IconCards />
                <div className="flex flex-row gap-1">
                  <div>Deck</div>
                  <div className="w-[24px]">({getDeckCount()})</div>
                </div>
              </div>
            }
          />
          <Tab
            key={LAYOUTS.STATS}
            title={
              <div className="flex items-center space-x-2">
                <IconChartPie />
                <span>Stats</span>
              </div>
            }
          />
        </Tabs>
      </div>
    </div>
  );
}
